export const CREATING_AUTHOR = "CREATING_AUTHOR";
export const UPDATING_AUTHOR = "UPDATING_AUTHOR";
export const AUTHOR_CREATED = "AUTHOR_CREATED";
export const AUTHOR_UPDATED = "AUTHOR_UPDATED";
export const ERROR_AUTHOR_CREATE = "ERROR_AUTHOR_CREATE";
export const ERROR_AUTHOR_UPDATE = "ERROR_AUTHOR_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
